<h2>{{title}}</h2>
<table>
{{#data}}
<tr>
{{#.}}
<td>{{.}}</td>
{{/.}}
</tr>
{{/data}}

</table>